// extracted by mini-css-extract-plugin
export default {"root":"title_root__aKlXt"};